import { useEffect, useRef, useState } from 'react'

export const useCollapseExpand = () => {
  const contentRef = useRef<HTMLDivElement | null>(null)
  const [isExpanded, setIsExpanded] = useState(false)
  const [isCollapsible, setIsCollapsible] = useState(false)

  useEffect(() => {
    const element = contentRef.current

    if (!element) {
      return
    }

    setIsCollapsible(element.scrollHeight > element.clientHeight)
  }, [])

  return {
    contentRef,
    isExpanded,
    isCollapsible,
    setIsExpanded,
  }
}
